<template>
  <v-dialog
    persistent
    :value="opened"
    width="600"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="cancel()"
    @keydown.enter="cancel()"
  >
    <v-card block flat>
      <v-card-title class="confirmation-title">
        <v-icon color="primary" class="confirmation--text mr-1">info</v-icon>
        {{ title }}
      </v-card-title>

      <v-card-text class="text-xs-left confirmation-text">
        {{ text }}
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          flat
          outline
          class="grey text-none font-weight-bold"
          @click="cancel()"
        >
          Cancel
        </v-btn>

        <v-btn
          class="primary text-none font-weight-bold"
          flat
          @click="proceed()"
        >
          Proceed
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
    },

    title: {
      type: String,
      required: true,
    },

    text: {
      type: String,
      required: true,
    },
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    proceed() {
      this.$emit('proceed');
    },
  },
};
</script>

<style lang="postcss" scoped>
.confirmation-title {
  font-size: 22px;
  font-weight: bold;
  padding-bottom: 0;
}

.confirmation-text {
  font-size: 16px;
}
</style>
